import { AtelierLink } from '@/components/admin/vitrine/atelier-link';
import { useInstanceContext, useIsVitrine } from '@/lib/use-instance';
import { VITRINE_WORDING, atelierHref, isVitrineModelScreen } from '@/lib/vitrine';
import { useRouterState } from '@tanstack/react-router';

/**
 * The banner of the vitrine, on the screens of a model (docs/specs/vitrine.md
 * section 7, maquette `vitrine.html`, review of 2026-10-14): « Vitrine - on n'y
 * modifie rien. Les modifications se font sur form.dev », and a button that
 * opens THE SAME OBJECT on form.dev.
 *
 * Only on the screens of a model (`isVitrineModelScreen`): Partage, Sessions
 * and Entretiens are written on the vitrine, and the sentence would be false
 * there. Nothing at all on the atelier.
 *
 * « Le même objet » is the path and the search of the page being read, joined
 * to `ATELIER_ORIGIN` as the server reports it. A vitrine that was not told
 * where the atelier is keeps the sentence and drops the button: a link to
 * nowhere would be worse than none.
 */

export function VitrineBanner() {
  const vitrine = useIsVitrine();
  const { atelierOrigin } = useInstanceContext();
  const { pathname, searchStr } = useRouterState({
    select: (state) => ({ pathname: state.location.pathname, searchStr: state.location.searchStr }),
  });
  if (!vitrine || !isVitrineModelScreen(pathname)) return null;
  const href = atelierHref(atelierOrigin, pathname, searchStr);
  return (
    <div
      data-testid="vitrine-bandeau"
      className="mb-6 flex flex-wrap items-center gap-x-3 gap-y-1.5 rounded-md border border-bleu-ciel bg-bleu-ciel-tint px-3 py-2 text-bleu-ciel-deep text-small"
    >
      <p className="min-w-50 flex-1">
        <b className="font-bold">{VITRINE_WORDING.bannerTitle}</b> {VITRINE_WORDING.bannerRest}
      </p>
      {href === null ? null : (
        <AtelierLink href={href} data-testid="vitrine-ouvrir-atelier">
          {VITRINE_WORDING.openAtelier}
        </AtelierLink>
      )}
    </div>
  );
}
